import React from "react";
import { InputRangeRow } from "./index";
// Used by Heli KV2008B and Heli KV2019B machines

export default function RollerImpulseRow() {
   return (
      <InputRangeRow
         titleProp={"Roller Impulse"}
         descriptionProp={"pulse/r"}
         sizeProp={6}
         colSizeProp={6}
         typeProp={"text"}
         minProp={8}
         maxProp={200}
         propertyNameProp={"rollerImpulse"}
         errorDialogueProp={"8-200 only"}
         floatProp={false}
      />
   );
}
